// YoutubeThumbnail — img <img> liviana que carga el hqdefault.jpg de
// YouTube para un schema con video_url. Fallback gracioso a placeholder
// con ícono play si la URL no es parseable o la imagen falla a cargar.
//
// Sprint 3 PR4 — usado por BibliotecaEjercicios + PrescribirRutina.
// NO embed pesado (iframe) — solo una img tag. El embed completo solo
// se usa en VideoOnlyView durante la sesión del paciente.

import { useState } from "react";
import { PlayCircle } from "lucide-react";
import { getYoutubeThumbnailUrl } from "@/lib/pose/youtube";

interface Props {
  /** URL completa del video (watch?v=, youtu.be/, embed/). undefined =
   *  ejercicio sin video tutorial — renderea placeholder. */
  videoUrl: string | undefined;
  /** Para `alt` accesible. */
  exerciseName: string;
  /** Override del shape — default aspect-video. Pasale aspect-square u
   *  otro si querés cambiar. */
  className?: string;
}

export function YoutubeThumbnail({
  videoUrl,
  exerciseName,
  className = "aspect-video",
}: Props) {
  const [errored, setErrored] = useState(false);
  const thumbnailUrl = getYoutubeThumbnailUrl(videoUrl);

  const showFallback = !thumbnailUrl || errored;

  return (
    <div
      className={`w-full bg-muted rounded-lg overflow-hidden flex items-center justify-center ${className}`}
    >
      {showFallback ? (
        <PlayCircle
          className="w-10 h-10 text-muted-foreground/60"
          strokeWidth={1.25}
        />
      ) : (
        <img
          src={thumbnailUrl}
          alt={`Video tutorial: ${exerciseName}`}
          loading="lazy"
          onError={() => setErrored(true)}
          className="w-full h-full object-cover"
        />
      )}
    </div>
  );
}
